import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { MainPage } from '../pages/main/main';
// import { TutorialPage } from '../pages/tutorial/tutorial';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
      // if (localStorage.getItem('Init')) {
      this.rootPage = MainPage;
      // } else {
      //   this.rootPage = TutorialPage;
      // }
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts